// extracted by mini-css-extract-plugin
export var category = "style-module--category--humPK";
export var collapsible = "style-module--collapsible--LxNEZ";
export var imglyTypoButton = "style-module--imgly--typo-button--Hl9Dx";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--VaF5H";
export var imglyTypoH1 = "style-module--imgly--typo-h1--W0USO";
export var imglyTypoH2 = "style-module--imgly--typo-h2--3P4NG";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--9OGqj";
export var imglyTypoH3 = "style-module--imgly--typo-h3--iO8pC";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text---etXl";
export var imglyTypoH4 = "style-module--imgly--typo-h4--mrlDQ";
export var imglyTypoH5 = "style-module--imgly--typo-h5--UybLz";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--Gwryj";
export var imglyTypoIcon = "style-module--imgly--typo-icon--FWBUM";
export var imglyTypoLink = "style-module--imgly--typo-link--296FY";
export var imglyTypoOverline = "style-module--imgly--typo-overline--Wap2V";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--Pgys-";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--+mdMP";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--yOOs6";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--gicPv";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--mWJCd";
export var imglyTypoSubline = "style-module--imgly--typo-subline--EmGpl";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--EcF0c";
export var naviLabelIsLarge = "style-module--navi-label-is-large--9FMIq";
export var naviLabelIsSmall = "style-module--navi-label-is-small--CJ54C";
export var root = "style-module--root--L67V4";
export var section = "style-module--section--hbegk";
export var subcategory = "style-module--subcategory--gM-+u";
export var subcategorytitle = "style-module--subcategorytitle--tZuEV";
export var title = "style-module--title--GBT6S";